var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"darkGradButton text-none",attrs:{"rounded":"","x-large":""},on:{"click":_vm.signUp}},[_c('h2',{staticClass:"buttonText"},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }